<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X3wWt5/tc-custom/9781610580595.jpg?1702641946694" alt="This image is the cover for the book Hearty Vegan Meals for Monster Appetites"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hearty Vegan Meals for Monster Appetites
      </h1>
      <p class="bookDescription body article font2">
        <p>Veganism is one of the hottest health trends going. But what do you do when half the people at your dinner table rebel against organic greens in favor of burgers, stew, and meat-based fare? And who has the time or inclination to prepare 2-3 different meals to please everyone? Hearty Vegan Meals for Monster Appetites gives 200 recipes that a die-hard comfort food eater will love. Utilizing substantial ingredients packed with flavor such as portabella mushrooms, sweet potatoes, whole grains, and beans readers can enjoy delicious burgers, stews, chilis, pastas, hearty main dishes, casseroles and comforting breads and desserts. Your family won’t be missing out with recipes like Maple-Glazed doughnuts with Faux Bacon bits, crispy Mac ‘n cheese balls, Patty melts and peanut butter cupcakes. Each dish is abundant and satisfying so that no one at the table feels shortchanged.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Celine Steen, Joni Marie Newman
      </h2>
      
      <p class="authorDescription body article">Celine Steen is the co-author of 500 Vegan Recipes, The Complete Guide to Vegan Food Substitutions, Hearty Vegan Meals, Vegan Sandwiches Save the Day!, Whole Grain Vegan Baking, The Great Vegan Protein Book, and The Great Vegan Grains Book. She is the founder of the award-winning blog Have Cake, Will Travel (havecakewilltravel.com).Joni Marie Newman is the founder of justthefood.com and the author of 10 vegan cookbooks, including 500 Vegan Recipes, The Complete Guide to Vegan Food Substitutions, Hearty Vegan Meals, and Vegan Food Gifts. Joni is well-known in the vegan community and frequently speaks at vegan conferences, cooking demos, and other events. She likes to spread the vegan love on Twitter @JoniMarieNewman.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aa8099a2